import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './DiagnosticBanner.styles';

export function DiagnosticBanner() {
  const slots = styles();

  return (
    <div
      className={slots.base()}
      id="diagnostic-banner"
    >
      <div className={slots.content()}>
        <h3 className={slots.title()}>
          Пройдите тест,
          <br className={slots.brDesktop()} /> чтобы подобрать уход,
        </h3>
        <p className={slots.text()}>который подойдет именно вам​</p>
        <a
          href="/survey/diagnostic/"
          className={slots.button()}
          target="_blank"
        >
          Пройти тест • &nbsp;5 мин
        </a>
      </div>
      <div className={slots.visual()}>
        <picture>
          <source
            srcSet={staticMediaUrl(
              'landing/bioderma_sebium/diagnostic-visual_sm.png'
            )}
            media="(max-width: 767px)"
          />
          <img
            className={slots.image()}
            src={staticMediaUrl(
              'landing/bioderma_sebium/diagnostic-visual.png'
            )}
            alt="Пройдите тест, чтобы подобрать уход, который подойдет именно вам​"
          />
        </picture>
      </div>
    </div>
  );
}
